import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BolusActivatedPayload = {
  bolus_id: number;
  iob?: number;
  bolus_size?: number;
};

export type BolusActivatedEvent = {
  bolusId: number;
  iob?: number;
  bolusSize?: number;
};

const bolusActivatedSchema = z.object({
  bolus_id: z.number(),
  iob: cz.permissive(z.number()),
  bolus_size: cz.permissive(z.number()),
});

export const LID_BOLUS_ACTIVATED = {
  value: 0x37,
  name: "Bolus Activated Event",
  format: "h..ff....",
  fields: ["bolus_id", "iob", "bolus_size"],
  postprocess: rec => ({
    bolusId: rec.bolus_id,
    iob: rec.iob,
    bolusSize: rec.bolus_size,
  }),
  schema: bolusActivatedSchema,
} as const satisfies TandemEventDefinition<BolusActivatedPayload, BolusActivatedEvent>;
